import { memo } from "react";
import { useMutation } from "react-query";
import { Button, Flex, Form, Spin } from "antd";
import { useTranslation } from "react-i18next";

import { mdlCopyBoardsToOtherHotelsRequest } from "../../models/service-models/board/CopyBoardsToOtherHotelsRequest";
import { HotelSelect } from "../common/HotelSelect";
import { toast } from "react-toastify";
import { BoardService } from "../../services/BoardService";
import { ObjectHelper } from "../../utils/ObjectHelper";
import { mdlCopyUserToOtherHotelsRequest } from "../../models/service-models/user/CopyUserToOtherHotelsRequest";
import { UserService } from "../../services/UserService";

export type UserCopyProps = {
    userName?: string;
    hotelId?: string;
    callback?: Function;
}


export const UserCopy = memo(function UserCopy(props: UserCopyProps) {
    const { t } = useTranslation();
    const [form] = Form.useForm();

    const { mutateAsync: saveUser, isLoading: mutateLoading, data: mutateData } = useMutation(
        (data: mdlCopyUserToOtherHotelsRequest) => UserService.CopyUserToOtherHotels(data as mdlCopyUserToOtherHotelsRequest),
        {
            onMutate(variables) {
                variables.hotelId = props.hotelId;
                variables.userName = props.userName!
            },
            onError: error => {
                console.log(error);
            },
            onSuccess(data, variables, context) {
                if (data.header && data.header.success) {
                    toast.success(t("common.success"));
                    props.callback && props.callback();
                }
                else {
                    toast.error(ObjectHelper.getErrorMessage(data.header.messages));
                }
            },
        }
    );

    return (
        <>
            <Spin spinning={mutateLoading}>

                <Form
                    form={form}
                    name="board-form"
                    layout="vertical"
                    onFinish={async (values) => saveUser(values)}
                    autoComplete="off"
                >
                    <Form.Item<mdlCopyUserToOtherHotelsRequest>
                        label={t("definitions.users.hotels")}
                        name="hotelIds"
                        rules={[{ required: true, message: t("common.required") }]}
                    >
                        <HotelSelect onChange={(value: string[]) => form.setFieldsValue({ hotelIds: value })} mode="multiple" />
                    </Form.Item>

                    <Form.Item>
                        <Flex align={"center"} justify="flex-end">
                            <Button type="primary" htmlType="submit">{t("common.save")}</Button>
                        </Flex>
                    </Form.Item>
                </Form>

            </Spin>
        </>
    )
})
